import domready from "domready";
import "../elements/navigation--viewport";
var viewport;
domready(function () {
  var languages = document.querySelector(".wrap--navigation .navigation.navigation--language");
  var contactInfo = document.querySelector(".navigation-contact");
  viewport = window.navigationViewport;
  if (languages) {
    if (languages !== null && contactInfo !== null && viewport === "desktop") {
      languages.style.right = contactInfo.offsetWidth + 16 + "px";
    } else {
      languages.style.right = "";
    }
  } else {
    return;
  }
  window.addEventListener("navigationChange", function () {
    viewport = window.navigationViewport;
    if (languages !== null && contactInfo !== null && viewport === "desktop") {
      languages.style.right = contactInfo.offsetWidth + 16 + "px";
    } else {
      languages.style.right = "";
    }
  });
});
